// Utils
import styles from './distributornote.css'

type DistributorNoteProps = {
  note: string
}

const DistributorNote = ({ note }: DistributorNoteProps): JSX.Element => {
  return (
    <div className={styles.distributorNoteWrapper}>
      <strong>NOTE:&nbsp;</strong>
      <span>{note}</span>
    </div>
  )
}

export default DistributorNote
